import React, { useEffect, useRef, useState } from "react";

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholder?: string; // 可选：占位图
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  placeholder,
  ...rest
}) => {
  const imgRef = useRef<HTMLImageElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      ref={imgRef}
      src={inView ? src : placeholder}
      alt={alt}
      onLoad={() => setIsLoaded(true)}
      style={{
        ...rest.style,
      }}
      {...rest}
    />
  );
};

export default React.memo(LazyImage);
